import md5 from 'md5';

function getDataType(data) {
  return Object.prototype.toString.call(data);
}

function array2Str(data) {
  if (getDataType(data) === '[object Array]') {
    return data.join(',');
  } else {
    return data;
  }
}

function requestParamsFormat(config) {
  let newParams = {};
  let encryptParams = {};
  let { method, data, params, headers, header } = config;
  let oldParams = data || params;
  if (headers === undefined) {
    headers = header;
  }
  if (oldParams) {
    if (getDataType(oldParams) === '[object Array]') {
      newParams = encryptParams = oldParams;
    } else if (getDataType(oldParams) === '[object Object]') {
      Object.keys(oldParams)
        .sort()
        .forEach(key => {
          const currentValue = oldParams[key];
          newParams[key] = currentValue === null || currentValue === undefined ? '' : currentValue;
          if (method === 'get' || headers['Content-Type'] === 'application/x-www-form-urlencoded') {
            encryptParams[key] =
              currentValue === null || currentValue === undefined ? '' : typeof currentValue === 'number' ? String(currentValue) : array2Str(currentValue);
          } else {
            encryptParams[key] = newParams[key];
          }
        });
    }
  }

  if (method === 'post' && Object.keys(newParams).length > 0) {
    config.data = newParams;
  } else if (method === 'get') {
    config.params = newParams;
  }
  let ciphertext = md5(JSON.stringify(encryptParams));
  headers['signMsg'] = md5(ciphertext.slice(22) + ciphertext.slice(12, -10) + ciphertext.slice(0, 12));
}

export default requestParamsFormat;
